<button (click)="scrollToTop()"><img src="../../assets/svg/icons/arrow-up.svg"></button>